import { useGetTicketGpsBreadcrumbsQuery } from "@ots-frontend/ots-data";
import { skipToken } from "@reduxjs/toolkit/query";
import { useMemo } from "react";
import { ActivityRouteMap, type ActivityRouteMapProps, toActivityBreadcrumbs } from "../ActivityRouteMap";

export type ConnectedActivityRouteMapProps = Omit<ActivityRouteMapProps, "breadcrumbs">;

/** The ticket on the map with the driver's GPS breadcrumbs, loaded for the ticket (`/tickets/{id}/gps-breadcrumbs`). */
export const ConnectedActivityRouteMap = ({ entry, ...map }: ConnectedActivityRouteMapProps) => {
  const { data } = useGetTicketGpsBreadcrumbsQuery(entry.tta?.id ? { id: entry.tta.id, tenantCode: entry.tta.database } : skipToken);
  const breadcrumbs = useMemo(() => toActivityBreadcrumbs(data), [data]);
  return <ActivityRouteMap entry={entry} breadcrumbs={breadcrumbs} {...map}/>;
};
